import { takeLatest, put, call } from 'redux-saga/effects';
import {
  loginActions,
  loginCreatorType,
  getAllKidsCreatorType,
  getAllLocationType,
  getAllPlansCreatorType,
  createKidCreatorType,
  resetCreateKidSuccessCreatorType,
  getAllAddressCreatorType
} from '../slices/authSlice';
import {
  authenticateUser,
  getAllLocation,
  getAllKidsApi,
  getAllPlansApi,
  createKidAi,
  getAllAddressApi,
  saveRecurringPlanApi
} from '../apiCalls/LoginApi';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import { Platform } from 'react-native';
// Saga to handle user login

const storeData = async (value) => {

  try {
    // Ensure value is a string before saving to AsyncStorage
    const stringValue = JSON.stringify(value);
    await AsyncStorage.setItem('token', value);
  } catch (e) {
    console.error('Error saving token to AsyncStorage data:', e);
  }
};

const storeData1 = async (value) => {

  try {
    // Ensure value is a string before saving to AsyncStorage
    const stringValue = JSON.stringify(value);
    await AsyncStorage.setItem('userId', value);
  } catch (e) {
    console.error('Error saving userId to AsyncStorage data:', e);
  }
};

const storeData2 = async (value) => {
  console.log("setting this", value)
  try {
    const stringValue = JSON.stringify(value);
    await AsyncStorage.setItem('userType', value);
  } catch (e) {
    console.error('Error saving userType to Async Storage', e);
  }
}


function* handleLogin(action) {
  try {
    const { emailOrUserId, password, loginType } = action.payload;
    const user = yield call(
      authenticateUser,
      emailOrUserId,
      password,
      loginType
    );



    if (user.Data?.user) {
      yield put(loginActions.setuserId(user?.Data?.user?.userId))
      console.log('user', user?.Data?.user)
    }
    if (user?.Data?.user?.userId || user?.Data?.user?.staffId) {
      yield put(loginActions.setToken(user?.Data?.user?.userId || user?.Data?.user?.staffId))
      yield call(storeData1, user?.Data?.user?.userId || user?.Data?.user?.staffId);
    } else {
      console.log('No userId or staffId found in the user object');
    }

    if (user?.Data?.token) {
      yield put(loginActions.setToken(user?.Data?.token))
      yield call(storeData, user.Data.token);
    } else {
      console.log('No token found in the user object');
    }

    yield put(loginActions.setuserType(user?.Data?.adminlogin ? "admin" : "parent"));
    yield call(storeData2, user?.Data?.adminlogin ? "admin" : "parent");


    yield put(loginActions.loginUserSuccess(user));

    // Check for eventId in URL and handle redirect
    if (Platform.OS === 'web') {
      const urlParams = new URLSearchParams(window.location.search);
      const eventId = urlParams.get('eventId');

      if (eventId) {
        // Redirect to event details with just eventId
        window.location.href = `/event-details?eventId=${eventId}`;
      }
    }
  } catch (error) {
    yield put(loginActions.loginUserFailure(error.message));
  }
}

// Watcher saga
export function* authSagaWatcher() {
  yield takeLatest(loginCreatorType, handleLogin);
}

function* getAllLocations(action) {
  try {
    loginActions?.getAllLocationSuccess(false);
    const response = yield call(getAllLocation);
    yield put(loginActions.getAllLocation(response));
  } catch (error) {
    yield put(loginActions.getAllLocationFailure(error.message));
  }
}

// Watcher saga
export function* getAllLocationsWatcher() {
  yield takeLatest(getAllLocationType, getAllLocations);
}

function* getAllKidsSaga(action) {
  try {
    loginActions?.getAllKidsSuccess(false);
    const response = yield call(getAllKidsApi);
    yield put(loginActions.getAllKids(response));
  } catch (error) {
    yield put(loginActions.getAllKidsFailure(error.message));
  }
}

// Watcher saga
export function* getAllKidsWatcher() {
  yield takeLatest(getAllKidsCreatorType, getAllKidsSaga);
}



function* getAllPlansSaga() {
  try {
    loginActions?.getAllPlansSuccess(false);
    const response = yield call(getAllPlansApi);
    yield put(loginActions.getAllPlans(response));
  } catch (error) {
    yield put(loginActions.getAllPlansFailure(error.message));
  }
}

// Watcher saga
export function* getAllPlansWatcher() {
  yield takeLatest(getAllPlansCreatorType, getAllPlansSaga);
}



function* createKidSaga(action) {
  const { obj } = action.payload;
  try {
    loginActions?.createKidSuccess(false);
    const response = yield call(createKidAi, obj);
    if (response?.Success == 1) {
      yield put(loginActions.createKid(response))
      yield put(loginActions?.createKidSuccess(true))
    }

  } catch (error) {
    yield put(loginActions.createKidFailure(error.message));
  }
}

export function* resetCreateKidSuccessSaga() {
  try {
    yield put(loginActions.createKidSuccess(false))
  } catch (error) {
    console.error('Saga Error:', error);
    yield put(loginActions.createKidFailure(error.message));
  }
}

// Watcher saga
export function* createKidWatcher() {
  yield takeLatest(createKidCreatorType, createKidSaga);
}

// Watcher saga
export function* resetCreateKidSuccessWatcher() {
  yield takeLatest(resetCreateKidSuccessCreatorType, resetCreateKidSuccessSaga);
}


function* getAllAddressSaga() {
  try {
    yield put(loginActions.setAllAddressSuccess(false))
    const response = yield call(getAllAddressApi);
    yield put(loginActions.setAllAddress(response));
  } catch (error) {
    console.error('Saga Error:', error);
    yield put(loginActions.setAllAddressFailure(error.message));
  }
}

// Watcher saga saveRecurringPlanApi
export function* getAllAddressWatcher() {
  yield takeLatest(getAllAddressCreatorType, getAllAddressSaga);
}


function* saveRecurringPlanSaga() {
  try {
    yield put(loginActions.saveRecurringLoader(false))
    const response = yield call(saveRecurringPlanApi);
    yield put(loginActions.setAllAddress(response));
  } catch (error) {
    console.error('Saga Error:', error);
    yield put(loginActions.setAllAddressFailure(error.message));
  }
}

// Watcher saga 
export function* saveRecurringPlanWatcher() {
  yield takeLatest(getAllAddressCreatorType, saveRecurringPlanSaga);
}
